import React from 'react';
import { useSnackbar } from "notistack";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { validateEmailAddress } from '../../Utils/validateEmailAddress.js';
import { snackAction } from '../../components/CustomSnakbar.jsx'

export default function CcPopup({
    openCc,
    cc,
    allCc,
    setOpenCc,
    setCc,
    setAllCc
}) {

    const { enqueueSnackbar } = useSnackbar();

    const handleCloseCc = () => {
        setOpenCc(false);
    };

    const addCc = () => {
        setCc('');
        if (cc && cc.length > 0) {
            validateEmailAddress(cc) ? setAllCc([...allCc, cc]) : enqueueSnackbar(`Ingrese un Email válido`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
        }
        handleCloseCc();
    }

    return (
        <div>
            <Dialog open={openCc} fullWidth={true}
                maxWidth="xs" onClose={handleCloseCc}>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Ingrese un email"
                        fullWidth
                        variant="standard"
                        onChange={e => setCc(e.target.value)}
                        value={cc}
                    />
                </DialogContent>
                <DialogActions style={{ justifyContent: "center" }}>
                    <Button variant="contained" size="small" onClick={addCc}>ACEPTAR</Button>
                    <Button variant="contained" size="small" color="error" onClick={handleCloseCc}>CANCELAR</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
